// import React from "react";
// import "./style/CardExplore.css";
// import VillaCard from "../villacard/VillaCard";

// function CardExplore({ villa, lang, setCurrentFloor, onOpenModal, isMobile }) {
//   return (
//     <div className="card-explore">
//       {villa ? (
//         <VillaCard page="explore-tour" villa={villa} lang={lang} setCurrentFloor={setCurrentFloor} onOpenModal={onOpenModal} isMobile={isMobile}  />
//       ) : (
//         <p style={{ color: "white" }}>No villa selected</p>
//       )}
//     </div>
//   );
// }

// export default CardExplore;






// CardExplore.jsx
// CardExplore.jsx
import React from "react";
import "./style/CardExplore.css";
import VillaCard from "../villacard/VillaCard";

// 1. ضيفي currentFloor في الـ props هنا
function CardExplore({ villa, lang, currentFloor, setCurrentFloor, onOpenModal, isMobile, floorsData }) {
  return (
    <div className="card-explore">
      {villa ? (
        <VillaCard 
          page="explore-tour" 
          villa={villa} 
          lang={lang} 
          currentFloor={currentFloor} // 2. مرري القيمة الحالية هنا
          setCurrentFloor={setCurrentFloor} 
          onOpenModal={onOpenModal} 
          isMobile={isMobile}  
          floorsData={floorsData} 
        />
      ) : (
        <p style={{ color: "white" }}>No villa selected</p>
      )}
    </div>
  );
}

export default CardExplore;